module.exports = __webpack_public_path__ + "img/08.e50cc7e4.png";